import { useState, useEffect } from "react";
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig, isAuthConfigured } from "./msalConfig";

function AuthProvider({ children }) {
  const [instance, setInstance] = useState(null);

  useEffect(() => {
    if (!isAuthConfigured()) {
      setInstance("disabled");
      return;
    }
    const init = async () => {
      const pca = new PublicClientApplication(msalConfig);
      await pca.initialize();
      setInstance(pca);
    };
    init();
  }, []);

  if (!instance) {
    return <div style={{ padding: "2rem", textAlign: "center" }}>Loading…</div>;
  }

  if (instance === "disabled") {
    return children;
  }

  return <MsalProvider instance={instance}>{children}</MsalProvider>;
}

export default AuthProvider;
